import { render, staticRenderFns } from "./LogbooksMod.vue?vue&type=template&id=294b1452"
import script from "./LogbooksMod.vue?vue&type=script&lang=js"
export * from "./LogbooksMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports